import React from "react";
import { Dialog, FlatButton, RaisedButton } from "material-ui";
import { Link } from "react-router";
import moment from "moment";
import { Table } from "reactable";

import config from "../config";
import * as util from "../util";

import StatsBlockContainer from "./partials/stats-block-container.jsx";
import StatsBlock from "./partials/stats-block.jsx";
import LinkLike from "./partials/link-like.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import InjectedSelect from "./partials/injected-select.jsx";
import InfoNotice from "./partials/info-notice.jsx";

import FilmStore from "../stores/FilmStore";
import FilmActions from "../actions/FilmActions";
import UserStore from "../stores/UserStore";
import BallotActions from "../actions/BallotActions";

class BallotingTabulate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabulationRequested: false,
      shownTabulation: null,
      shownTabulationTagFilter: null
    };

    this.run = this.run.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  run() {
    if (!window.confirm("Are you sure you would like to run the tabulation?")) {
      return;
    }

    BallotActions.tabulate.defer(this.props.eventBucket.id);
  }

  componentWillMount() {
    BallotActions.fetchTabulations.defer(this.props.eventBucket.id);
    FilmActions.fetchAllForEventBucket.defer(this.props.eventBucket.id);
  }

  getStyles() {
    return {
      header: {
        marginTop: "1em",
        marginBottom: 0
      }
    };
  }

  render() {
    const styles = this.getStyles();
    const { eventBucket, ballotStats, ballotTabulations, settings, isWorking } =
      this.props;
    const { shownTabulation, shownTabulationTagFilter } = this.state;
    const name = UserStore.getState().data.name;

    if (!ballotStats) {
      return <WorkingIndicator fullPage={true} />;
    }

    const tabulationRows =
      shownTabulation &&
      shownTabulation.scores
        .map(s => {
          const film = FilmStore.getFilmById(s.film);

          if (
            shownTabulationTagFilter &&
            (!film || !film.tags.some(t => t.id === shownTabulationTagFilter))
          ) {
            return false;
          }

          if (typeof s.score !== "number") {
            return false;
          }

          return {
            Film: film ? film.name : `Film #${s.film}`,
            Score: s.score.toFixed(5)
          };
        })
        .filter(s => !!s);

    return (
      <div>
        <Dialog
          title={
            shownTabulation &&
            `Tabulation on ${moment(shownTabulation.created_at).format("lll")}`
          }
          modal={false}
          open={!!shownTabulation}
          bodyStyle={{ overflowY: "scroll" }}
          actions={[
            <FlatButton
              onClick={() => {
                window.open(
                  `${config.endpoint}ballots/tabulations/${
                    shownTabulation.id
                  }/raw_votes.csv?${UserStore.makeApiKeyQueryString()}`
                );
              }}
              primary={true}
              label="Download raw votes"
            />,
            <FlatButton
              onClick={
                tabulationRows && tabulationRows.length
                  ? () => {
                      util.clientSideDownload(
                        `tabulation-${util.snakeCase(
                          eventBucket.name
                        )}-${util.snakeCase(shownTabulation.created_at)}.csv`,
                        "text/csv",
                        util.makeCsv(
                          [["Film", "Score"]].concat(
                            tabulationRows.map(r => [r.Film, r.Score])
                          )
                        )
                      );
                    }
                  : () => {}
              }
              primary={true}
              label="Download as CSV"
            />,
            <FlatButton
              label="Close"
              primary={true}
              onClick={() => this.setState({ shownTabulation: null })}
            />
          ]}
          onRequestClose={() => this.setState({ shownTabulation: null })}
        >
          {shownTabulation ? (
            <div>
              <p>
                This tabulation was requested by{" "}
                {shownTabulation.user_account.name} and follows the{" "}
                <code>
                  {shownTabulation.balloting_config.design}/
                  {shownTabulation.balloting_config.tabulation_method}
                </code>{" "}
                methodology. {shownTabulation.stats.total} ballots were
                evaluated to generate the following result. Higher is better.
              </p>
              <InjectedSelect
                value={shownTabulationTagFilter}
                label="Filter by tag"
                placeholderText="All films shown"
                type="tags"
                eventBucketId={eventBucket.id}
                labelFormatter={t => t.name}
                onChange={v => this.setState({ shownTabulationTagFilter: v })}
                style={{ marginBottom: "1.5em", maxWidth: 400 }}
              />
              <Table
                className={"bordered striped responsive-table"}
                data={tabulationRows}
              />
              {tabulationRows.length === 0 ? (
                <div className="empty-table-message">No films found.</div>
              ) : null}
            </div>
          ) : null}
        </Dialog>
        <p>
          When you're ready, you can tabulate results for {eventBucket.name}. To
          avoid bias, preliminary results are never shown. After a tabulation is
          run, your user account ({name}), location, tabulation method &
          results, and the current date and time will be permanently logged.
        </p>
        <InfoNotice style={{ marginBottom: "1em", fontSize: "10pt" }}>
          Check out our{" "}
          <a
            href="https://help.eventive.org/eventive-balloting/tabulating-results"
            target="_blank"
          >
            guide to tabulating results
          </a>
          .
        </InfoNotice>
        <StatsBlockContainer>
          {[
            <StatsBlock
              key="total"
              value={ballotStats.total}
              label="Ballots recorded"
            />
          ]}
        </StatsBlockContainer>
        <h3 style={styles.header}>Previously run tabulations</h3>
        {ballotTabulations.length ? (
          <div>
            <Table
              className={"bordered striped responsive-table"}
              style={{ marginTop: "1em" }}
              data={ballotTabulations
                .sort((a, b) => b.created_at.localeCompare(a.created_at))
                .map(t => {
                  return {
                    User: t.user_account.name,
                    Date: moment(t.created_at).format("lll"),
                    Mode: t.balloting_config.design,
                    Method: t.balloting_config.tabulation_method,
                    "# ballots": t.stats.total,
                    View: (
                      <span>
                        <LinkLike
                          onTouchTap={() =>
                            this.setState({ shownTabulation: t })
                          }
                        >
                          View results
                        </LinkLike>
                      </span>
                    )
                  };
                })}
            />
          </div>
        ) : (
          <p>
            {isWorking ? (
              <i>Loading previously run tabulations...</i>
            ) : (
              <i>No tabulations have been run, so far</i>
            )}
          </p>
        )}
        <h3 style={styles.header}>Confirm & run new tabulation</h3>
        <ul>
          <li>
            User: <code>{name}</code>
          </li>
          <li>
            Date: <code>{moment().format("lll")}</code>
          </li>
          <li>
            Ballot mode: <code>{settings.design}</code>
          </li>
          <li>
            Tabulation method: <code>{settings.tabulation_method}</code>
          </li>
          <li>
            Number of ballots: <code>{ballotStats.total}</code>
          </li>
        </ul>
        <RaisedButton
          primary
          disabled={this.state.tabulationRequested && isWorking}
          label={
            this.state.tabulationRequested && isWorking
              ? "Running new tabulation..."
              : "Run new tabulation..."
          }
          onClick={this.run}
        />
      </div>
    );
  }
}

export default BallotingTabulate;



// WEBPACK FOOTER //
// ./src/app/components/balloting-tabulate.jsx